export enum UserType {
  ADVERTISER = 'advertiser', // 广告主员工
  AGENCY = 'agency', // 服务商员工
  PARTNER = 'partner', // 合作伙伴员工
  ELSE = 'else', // 其他
}

export const UserTypeNameMap = {
  [UserType.ADVERTISER]: '广告主员工',
  [UserType.AGENCY]: '服务商员工',
  [UserType.PARTNER]: '合作伙伴员工',
  [UserType.ELSE]: '其他类型',
};
